import React, { useState, useEffect, useRef } from 'react';
import BackupOutlinedIcon from '@material-ui/icons/BackupOutlined';
import PlaylistAddCheckOutlinedIcon from '@material-ui/icons/PlaylistAddCheckOutlined';
import SyncRoundedIcon from '@material-ui/icons/SyncRounded';
import styles from './audit.module.css';
import * as _ from 'lodash';
import moment from 'moment';
import EditImage from '../../images/icons/editImage.svg';
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline'; //ocr success
import CancelOutlinedIcon from '@material-ui/icons/CancelOutlined'; //ocr fail
import VerifiedUserOutlinedIcon from '@material-ui/icons/VerifiedUserOutlined'; //data verified
import doc_uploaded from '../../images/icons/doc_uploaded.svg';
import SystemUpdateAltOutlinedIcon from '@material-ui/icons/SystemUpdateAltOutlined';
import NoteOutlinedIcon from '@material-ui/icons/NoteOutlined';
import statusChanged from '../../images/icons/statusChanged.svg';
const { vertical_line, circle, withoutVerticalLine } = styles;

const AuditActivity = ({ each, page, index }) => {
  const [more, setMore] = useState(false);
  const [showless, setShowLess] = useState(false);
  const [shortMessage, setShortMessage] = useState('');
  const [isItEnd, setEnd] = useState(false);
  const [height, setHeight] = useState('');
  const HistoryRef = useRef(null);

  let message = each.message.toString();

  useEffect(() => {
    if (message.length < 50) {
      setShortMessage(message);
    } else {
      setShortMessage(message.substring(0, 50));
      setMore(true);
    }
  }, []);

  const showMoreContent = () => {
    if (showless) {
      setShortMessage(message.substring(0, 50));
      setMore(true);
      setShowLess(false);
    } else {
      setShortMessage(message);
      setMore(false);
      setShowLess(true);
    }
  };
  const getDate = () => {
    if (moment().isSame(moment(each.timestamp).format('YYYY-MM-DD'), 'day')) {
      return 'Today';
    }
    let date = moment(moment(each.timestamp).date(), 'DD').format('Do'),
      month = moment()
        .month(each.timestamp)
        .format('MMM');
    return date + ' ' + month;
  };
  const geTime = () => {
    return moment(each.timestamp).format('hh:mmA');
  };

  const getImage = () => {
    let Image;
    if (each.eventType == 'CREATED')
      Image = <img src={EditImage} style={{ color: '#00ACB8' }} />;
    else if (each.eventType == 'APPLICANT_ADDED')
      Image = <PlaylistAddCheckOutlinedIcon style={{ color: '#00ACB8' }} />;
    else if (each.eventType == 'DOC_UPLOADED')
      Image = <img src={doc_uploaded} style={{ color: '#00ACB8' }} />;
    else if (each.eventType == 'DOC_OCR_SUCCEEDED')
      Image = <CheckCircleOutlineIcon style={{ color: '#00ACB8' }} />;
    else if (each.eventType == 'DOC_OCR_FAILED')
      Image = <CancelOutlinedIcon style={{ color: 'red' }} />;
    else if (each.eventType == 'DATA_VERIFICATION_FAILED')
      Image = <VerifiedUserOutlinedIcon style={{ color: 'red' }} />;
    else if (each.eventType == 'DATA_VERIFIED')
      Image = <VerifiedUserOutlinedIcon style={{ color: '#00ACB8' }} />;
    else if (each.eventType == 'STATUS_CHANGED')
      Image = <img src={statusChanged} style={{ color: '#00ACB8' }} />;
    else if (each.eventType == 'DATA_UPDATED')
      Image = <SyncRoundedIcon style={{ color: '#00ACB8' }} />;
    else Image = <NoteOutlinedIcon style={{ color: '#00ACB8' }} />;
    return Image;
  };

  return (
    <div className="w-full flex  " ref={HistoryRef}>
      <div className="w-1/12">
        <div className={`${circle}  mx-auto `}> </div>
      </div>

      {_.get(page, 'totalElements', 0) > index + 1 ? (
        <div className={`${vertical_line}  mx-auto`}></div>
      ) : null}

      <div
        className={`${
          _.get(page, 'totalElements', 0) > index + 1 ? '' : withoutVerticalLine
        } w-full pl-7 pr-2 pb-5`}
      >
        <div className=" mr-auto bg-black-1005 rounded px-3 py-2 flex w-7/12">
          {getImage()}
          <span className="font-roboto font-normal text text-grey-2221 px-2  ">
            {getDate()}
            <span className="ml-2">{geTime()}</span>
          </span>
        </div>
        <div className=" mr-auto bg-black-1005 rounded px-3 py-2  w-12/12 my-3 px-3 py-2 block">
          <p className="font-roboto font-normal text-white font-sm text-left">
            {shortMessage}
          </p>
          {more || showless ? (
            <p
              className=" font-roboto font-medium text-orange-600 cursor-pointer text-left"
              onClick={showMoreContent}
            >
              {showless ? 'Show Less' : 'More'}
            </p>
          ) : null}
          <p className="text-grey-2221 font-roboto font-normal text-sm  pt-2 text-left">
            {each.userName}
          </p>
        </div>
      </div>
    </div>
  );
};

export default AuditActivity;
